<ng-container *transloco="let t">
  <p class="version" [attr.aria-hidden]="hidden" [ngClass]="{ hidden: hidden }">
    {{ product }} {{ t('ui.version') }} {{ appVersion }}
    <br />
    <span class="revision">
      {{ t('ui.revision') }}: {{ version + '-' + revision + (hidden ? '-' + npmVersion : '') }}
    </span>
  </p>
</ng-container>
